export class SearchDataDateView {
    public startDateTime: string;
    public endDateTime: string;
}